import axiosClient from '@/api/axiosClient';
import {
  API_GET_PRIZE_STATS,
  API_GET_LOGIN_STATS,
  API_GET_PRIZE_STATS_TRACKING,
  API_GET_REGISTER_REPORT,
  API_GET_REVENUE_REPORT,
  API_GET_PIECE_STATS,
  API_GET_TRACKING_DETAIL,
  API_GET_GAME_STATS,
} from '@/config/paths/API_PATH';

async function getPrizeStats({ startDate = null, endDate = null, prizeId = null, isdn = '' }) {
  const { data } = await axiosClient.get(API_GET_PRIZE_STATS, {
    params: {
      start_date: startDate,
      end_date: endDate,
      prize_id: prizeId,
      isdn,
    },
  });

  return data;
}

async function getPrizeStatsTracking({ id }) {
  const { data } = await axiosClient.get(API_GET_PRIZE_STATS_TRACKING, {
    params: {
      id,
    },
  });

  return data;
}

async function getTrackingDetails({ prizeId, numCollected, isdn, limit, offset }) {
  const { data } = await axiosClient.get(API_GET_TRACKING_DETAIL, {
    params: {
      id: prizeId,
      num_collected: numCollected,
      isdn,
      limit,
      offset,
    },
  });

  return data;
}

async function getLoginStats({ startDate = null, endDate = null }) {
  const { data } = await axiosClient.get(API_GET_LOGIN_STATS, {
    params: {
      start_date: startDate,
      end_date: endDate,
    },
  });

  return data;
}

async function getRegisterReport({ start_date, end_date, packageOption }) {
  const { data } = await axiosClient.get(API_GET_REGISTER_REPORT, {
    params: {
      start_date,
      end_date,
      package: packageOption,
    },
  });

  return data;
}

async function getRevenueReport({ start_date, end_date, packageOption }) {
  const { data } = await axiosClient.get(API_GET_REVENUE_REPORT, {
    params: {
      start_date,
      end_date,
      package: packageOption,
    },
  });
  return data;
}

async function getPieceStats({ report_month, isdn, limit, offset }) {
  const { data } = await axiosClient.get(API_GET_PIECE_STATS, {
    params: {
      report_month,
      isdn,
      limit,
      offset,
    },
  });
  return data;
}

async function getGameStats({ start_date, end_date }) {
  const { data } = await axiosClient.get(API_GET_GAME_STATS, {
    params: {
      start_date,
      end_date,
    },
  });

  return data;
}

export {
  getPrizeStats,
  getPrizeStatsTracking,
  getTrackingDetails,
  getLoginStats,
  getRegisterReport,
  getRevenueReport,
  getPieceStats,
  getGameStats,
};
